import _export from '../internals/export.js';
import stringMultibyte from '../internals/string-multibyte.js';

var $ = _export;
var codeAt = stringMultibyte.codeAt; // `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat

$({
  target: 'String',
  proto: true
}, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});
